import { createContext } from 'react';

const dialogConfig = {
  showDialog: false,
  type: 'success',
  content: '',
  isLoading: false,
  onConfirm: null,
  onCancel: null,
};

export const DialogContext = createContext(dialogConfig);
export const DispatchDialogContext = createContext(null);
